// extracted by mini-css-extract-plugin
export var colorSquare = "_me-0";
export var danger = "_me-5";
export var lightPink = "_me-8";
export var neutralBlue = "_me-7";
export var neutralYellow = "_me-6";
export var normal = "_me-1";
export var primary = "_me-2";
export var primaryLight = "_me-3";
export var solidBlack = "_me-g";
export var solidGreen = "_me-b";
export var solidLightBlue = "_me-d";
export var solidNavy = "_me-c";
export var solidOrange = "_me-f";
export var solidPink = "_me-e";
export var solidRed = "_me-9";
export var solidYellow = "_me-a";
export var success = "_me-4";